import React, { useContext } from "react"
import PropTypes from "prop-types"
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid-pro"
import { Box, Button } from "@mui/material"
import Budget2023Context from "context/budget2023/Budget2023Context"
import i18n from "i18n"
import useEntitlementGuard from "hooks/useEntitlementGuard"
import { DYNAMIC_ELEMENTS } from "constants/entitlements"

const CustomToolbar = ({
  bancoDePrecios,
  onAddEmptyDetail,
  showDynamicElementButton,
  projectId,
  isTender,
}) => {
  const { dynamicElement } = useContext(Budget2023Context)

  const [checkEntitlement, entitlementDialog] = useEntitlementGuard()

  const addDynamicElement = () => {
    if (!checkEntitlement(DYNAMIC_ELEMENTS, i18n.t("+ Elemento dinámico")))
      return

    dynamicElement.setModalIsOpen(true)
    dynamicElement.setProjectId(projectId)
  }

  return (
    <>
      <GridToolbarContainer sx={{ justifyContent: "space-between" }}>
        <GridToolbarColumnsButton />
        <Box sx={{ display: "flex", gap: 1 }}>
          {bancoDePrecios !== "BANCO DE PRECIOS REFERENCIA" && !isTender && (
            <Button onClick={onAddEmptyDetail} size="small">
              {i18n.t("+ Nuevo elemento")}
            </Button>
          )}
          {showDynamicElementButton && !isTender && (
            <Button onClick={addDynamicElement} size="small">
              {i18n.t("+ Elemento dinámico")}
            </Button>
          )}
        </Box>
      </GridToolbarContainer>
      {entitlementDialog}
    </>
  )
}

CustomToolbar.propTypes = {
  bancoDePrecios: PropTypes.string,
  onAddEmptyDetail: PropTypes.func.isRequired,
  showDynamicElementButton: PropTypes.bool,
  projectId: PropTypes.string,
  isTender: PropTypes.bool,
}

export default CustomToolbar
